<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Parametrização de Fila</app-titulo>
      <app-subtitulo>Defina o tipo de fila de cada terminal.</app-subtitulo>
    </div>

    <div class="grid-outline desktop">
      <div class="grid-header">
        <div class="intern-title">Terminais</div>
      </div>

      <app-loader [isLoading]="isLoading"></app-loader>

      <table *ngIf="!isLoading">
        <thead>
          <tr>
            <th class="col-terminal">Terminal</th>
            <th class="col-fila">Tipo de Fila</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of destinatarios">
            <td>{{ item.NM_DTNR }}</td>
            <td>
              <div class="select-wrapper" [class.disabled]="!podeEditar()">
                <select
                  [value]="item.FL_FILA_JNLA ? 'janela' : 'corrida'"
                  [disabled]="!podeEditar()"
                  (change)="alterarFila(item, $event)"
                >
                  <option value="corrida">Corrida</option>
                  <option value="janela">Janela</option>
                </select>
                <img src="assets/select-arrow.svg" class="chevron" alt="" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</app-layout>
